(function () {
  'use strict';

  // ── Countdown ────────────────────────────────────────────────────────
  function initCountdowns() {
    document.querySelectorAll('.wg-countdown[data-end]').forEach(function (el) {
      var end = new Date(el.dataset.end);
      if (isNaN(end.getTime())) return;

      function pad(n) { return String(n).padStart(2, '0'); }

      function tick() {
        var diff = end.getTime() - Date.now();
        if (diff <= 0) { el.setAttribute('hidden', ''); return; }
        el.querySelector('[data-unit="days"]').textContent    = Math.floor(diff / 86400000);
        el.querySelector('[data-unit="hours"]').textContent   = pad(Math.floor((diff % 86400000) / 3600000));
        el.querySelector('[data-unit="minutes"]').textContent = pad(Math.floor((diff % 3600000) / 60000));
        el.querySelector('[data-unit="seconds"]').textContent = pad(Math.floor((diff % 60000) / 1000));
      }

      tick();
      setInterval(tick, 1000);
    });
  }

  // ── Giveaway form ────────────────────────────────────────────────────
  function initForm() {
    var form = document.getElementById('wg-entry-form');
    if (!form) return;

    var submitBtn   = form.querySelector('.wg-form__submit');
    var successEl   = document.getElementById('wg-success');
    var globalErrEl = form.querySelector('.wg-form__global-err');

    function normPhone(raw) {
      var s = raw.replace(/[\s\-().]/g, '');
      if (/^0[45]\d{8}$/.test(s)) return '+61' + s.slice(1);
      if (/^\+61[45]\d{8}$/.test(s)) return s;
      return null;
    }

    function setErr(input, msgEl, msg) {
      input.classList.add('wg-form__input--err');
      if (msgEl) { msgEl.textContent = msg; msgEl.classList.add('wg-form__err-msg--on'); }
    }
    function clrErr(input, msgEl) {
      input.classList.remove('wg-form__input--err');
      if (msgEl) msgEl.classList.remove('wg-form__err-msg--on');
    }

    function validate() {
      var ok = true;
      var fn = form.querySelector('#wg-fn'), fnE = form.querySelector('#wg-fn-err');
      clrErr(fn, fnE);
      if (!fn.value.trim()) { setErr(fn, fnE, 'First name is required.'); ok = false; }

      var ln = form.querySelector('#wg-ln'), lnE = form.querySelector('#wg-ln-err');
      clrErr(ln, lnE);
      if (!ln.value.trim()) { setErr(ln, lnE, 'Last name is required.'); ok = false; }

      var em = form.querySelector('#wg-em'), emE = form.querySelector('#wg-em-err');
      clrErr(em, emE);
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(em.value.trim())) {
        setErr(em, emE, 'Please enter a valid email address.'); ok = false;
      }

      var ph = form.querySelector('#wg-ph'), phE = form.querySelector('#wg-ph-err');
      clrErr(ph, phE);
      if (!normPhone(ph.value.trim())) {
        setErr(ph, phE, 'Enter a valid AU mobile (e.g. 0412 345 678).'); ok = false;
      }

      var sms = form.querySelector('#wg-sms'), smsE = form.querySelector('#wg-sms-err');
      if (smsE) smsE.classList.remove('wg-form__err-msg--on');
      if (!sms.checked) {
        if (smsE) { smsE.textContent = 'SMS consent is required to enter.'; smsE.classList.add('wg-form__err-msg--on'); }
        ok = false;
      }

      var eml = form.querySelector('#wg-eml'), emlE = form.querySelector('#wg-eml-err');
      if (emlE) emlE.classList.remove('wg-form__err-msg--on');
      if (!eml.checked) {
        if (emlE) { emlE.textContent = 'Email consent is required to enter.'; emlE.classList.add('wg-form__err-msg--on'); }
        ok = false;
      }

      return ok;
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (globalErrEl) globalErrEl.classList.remove('wg-form__global-err--on');
      if (!validate()) return;

      submitBtn.disabled = true;
      var orig = submitBtn.textContent;
      submitBtn.textContent = 'Entering…';

      var phone = normPhone(form.querySelector('#wg-ph').value.trim());

      var payload = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Blackfish Giveaway',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email:        form.querySelector('#wg-em').value.trim(),
                  phone_number: phone,
                  first_name:   form.querySelector('#wg-fn').value.trim(),
                  last_name:    form.querySelector('#wg-ln').value.trim()
                }
              }
            }
          },
          relationships: {
            list: { data: { type: 'list', id: 'RLrSCP' } }
          }
        }
      };

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=UinWNa', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2026-04-15' },
        body: JSON.stringify(payload)
      })
      .then(function (res) {
        if (res.status === 202) {
          form.style.display = 'none';
          if (successEl) successEl.classList.add('wg-form__success--on');
        } else {
          return res.json().then(function (body) {
            var detail = (body.errors && body.errors[0] && body.errors[0].detail) || ('Status ' + res.status);
            throw new Error('[Klaviyo ' + res.status + '] ' + detail);
          });
        }
      })
      .catch(function (err) {
        submitBtn.disabled = false;
        submitBtn.textContent = orig;
        if (globalErrEl) {
          globalErrEl.textContent = 'Something went wrong. Please try again.';
          globalErrEl.classList.add('wg-form__global-err--on');
        }
        console.error('[WG Form]', err.message || err);
      });
    });
  }

  // ── Boot ─────────────────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initCountdowns(); initForm(); });
  } else {
    initCountdowns(); initForm();
  }
})();

